export default __webpack_public_path__ + "static/12-cctv-camera-d20dc3d7476f85d34588f16baff19cb7.png";